import React from 'react';
import {
  FaWallet,
  FaLayerGroup,
  FaCoins,
} from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';

const LevelIncome = () => {
    const { isDarkMode } = useTheme();

  const G = '#d4af37';
  const G2 = '#f0c842';

  const text = isDarkMode ? '#ffffff' : '#111111';
  const muted = isDarkMode ? '#9ca3af' : '#6b7280';

  const border = isDarkMode
    ? 'rgba(255,255,255,.06)'
    : 'rgba(0,0,0,.06)';

  const card = isDarkMode
    ? 'linear-gradient(145deg,#141414,#101010)'
    : 'linear-gradient(145deg,#ffffff,#faf8f3)';

  // DEMO DATA
  const levelData = [
    {
      level: 'Level 1',
      members: 12,
      commission: '10%',
      income: '₹2,450',
      status: 'Completed',
    },
    {
      level: 'Level 2',
      members: 18,
      commission: '8%',
      income: '₹1,860',
      status: 'Completed',
    },
    {
      level: 'Level 3',
      members: 24,
      commission: '5%',
      income: '₹980',
      status: 'Pending',
    },
    {
      level: 'Level 4',
      members: 8,
      commission: '3%',
      income: '₹420',
      status: 'Completed',
    },
  ];

  return (
    <div
      style={{
        width: '100%',
        padding: 20,
        borderRadius: 28,
        background: card,
        border: `1px solid ${border}`,

        boxShadow: isDarkMode
          ? '0 12px 35px rgba(0,0,0,.30)'
          : '0 12px 35px rgba(0,0,0,.05)',
      }}
    >

      {/* TOP HEADER */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16,
          marginBottom: 22,
        }}
      >

        {/* LEFT */}
        <div>
          <div
            style={{
              color: G,
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: 2,
              textTransform: 'uppercase',
              marginBottom: 5,
            }}
          >
            MLM Earnings
          </div>

          <div
            style={{
              fontSize: 26,
              fontWeight: 900,
              color: text,
              lineHeight: 1,
              marginBottom: 5,
            }}
          >
            Level Income
          </div>

          <div
            style={{
              color: muted,
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            Track your level commission income
          </div>
        </div>

        {/* TOTAL CARD */}
        <div
          style={{
            padding: '16px 18px',
            minWidth: 220,
            borderRadius: 20,

            background: isDarkMode
              ? '#1d1d1d'
              : '#ffffff',

            border: `1px solid ${border}`,

            display: 'flex',
            alignItems: 'center',
            gap: 14,
          }}
        >

          {/* ICON */}
          <div
            style={{
              width: 50,
              height: 50,
              borderRadius: 16,

              background: 'rgba(212,175,55,.12)',
              color: G,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              fontSize: 18,
            }}
          >
            <FaWallet />
          </div>

          {/* TEXT */}
          <div>
            <div
              style={{
                color: muted,
                fontSize: 11,
                fontWeight: 700,
                marginBottom: 4,
                textTransform: 'uppercase',
              }}
            >
              Total Income
            </div>

            <div
              style={{
                color: text,
                fontSize: 26,
                fontWeight: 900,
                lineHeight: 1,
              }}
            >
              ₹5,710
            </div>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div
        style={{
          background: isDarkMode
            ? '#1a1a1a'
            : '#ffffff',

          border: `1px solid ${border}`,
          borderRadius: 22,
          overflow: 'hidden',
        }}
      >

        {/* TABLE HEADER */}
        <div
          style={{
            padding: '18px 20px',
            borderBottom: `1px solid ${border}`,

            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: 14,

              background: 'rgba(212,175,55,.12)',
              color: G,

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              fontSize: 15,
            }}
          >
            <FaLayerGroup />
          </div>

          <div>
            <div
              style={{
                color: text,
                fontSize: 18,
                fontWeight: 800,
              }}
            >
              Income History
            </div>

            <div
              style={{
                color: muted,
                fontSize: 12,
                marginTop: 2,
              }}
            >
              All level commission earnings
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div
          style={{
            overflowX: 'auto',
            padding: 14,
          }}
        >
          <table
            style={{
              width: '100%',
              borderCollapse: 'separate',
              borderSpacing: '0 10px',
              minWidth: 700,
            }}
          >

      {/* HEAD */}
<thead>
  <tr
   style={{
                background: isDarkMode ? '#1d1d1d' : '#faf8f3',
              }} 
  >
    {[
      'Level',
      'Members',
      'Commission',
      'Income',
      'Status',
    ].map((head) => (
      <th
        key={head}
        style={{
          textAlign: 'left',
          padding: '12px 16px',         // ← uniform top/bottom + left/right padding

          color: muted,
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: 1,
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}
      >
        {head}
      </th>
    ))}
  </tr>
</thead>
            {/* BODY */}
            <tbody>
              {levelData.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    background: isDarkMode
                      ? '#222222'
                      : '#fafafa',

                    boxShadow: isDarkMode
                      ? '0 6px 16px rgba(0,0,0,.18)'
                      : '0 6px 16px rgba(0,0,0,.03)',
                  }}
                >

                  {/* LEVEL */}
                  <td
                    style={{
                      padding: '18px 16px',
                      borderTopLeftRadius: 16,
                      borderBottomLeftRadius: 16,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                      }}
                    >

                      {/* ICON */}
                      <div
                        style={{
                          width: 42,
                          height: 42,
                          borderRadius: 14,

                          background: `linear-gradient(135deg, ${G}, ${G2})`,
                          color: '#000',

                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',

                          fontSize: 15,
                          flexShrink: 0,
                        }}
                      >
                        <FaCoins />
                      </div>

                      {/* TEXT */}
                      <div>
                        <div
                          style={{
                            color: text,
                            fontSize: 14,
                            fontWeight: 800,
                            marginBottom: 3,
                          }}
                        >
                          {item.level}
                        </div>

                        <div
                          style={{
                            color: muted,
                            fontSize: 11,
                            fontWeight: 500,
                          }}
                        >
                          Referral Commission
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* MEMBERS */}
                  <td
                    style={{
                      padding: '18px 16px',
                      color: text,
                      fontSize: 14,
                      fontWeight: 700,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.members}
                  </td>

                  {/* COMMISSION */}
                  <td
                    style={{
                      padding: '18px 16px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',

                        padding: '7px 14px',
                        borderRadius: 30,

                        background: 'rgba(59,130,246,.12)',
                        color: '#3b82f6',

                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {item.commission}
                    </div>
                  </td>

                  {/* INCOME */}
                  <td
                    style={{
                      padding: '18px 16px',

                      color: G,
                      fontSize: 16,
                      fontWeight: 900,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.income}
                  </td>

                  {/* STATUS */}
                  <td
                    style={{
                      padding: '18px 16px',
                      borderTopRightRadius: 16,
                      borderBottomRightRadius: 16,
                    }}
                  >
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',

                        padding: '7px 14px',
                        borderRadius: 30,

                        background:
                          item.status === 'Completed'
                            ? 'rgba(16,185,129,.12)'
                            : 'rgba(245,158,11,.12)',

                        color:
                          item.status === 'Completed'
                            ? '#10b981'
                            : '#f59e0b',

                        fontSize: 11,
                        fontWeight: 700,
                      }}
                    >
                      {item.status}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LevelIncome;